export default "<div class=\"spinner-border text-dark\" role=\"status\"></div>\n<!-- Dashboard Filter Bar -->\n<dashboard-filter-bar> </dashboard-filter-bar>\n"